import { render, staticRenderFns } from "./Registries.vue?vue&type=template&id=59b8ae94&"
import script from "../registries.js?vue&type=script&lang=js&"
export * from "../registries.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports